module.exports = __webpack_public_path__ + "assets/img/home-typical-scenarios-icon2.ec34efee.png";